module.exports = __webpack_public_path__ + "img/font.53905d1b.svg";